import * as api from "../manipurCommon/API";
import Swal from "sweetalert2";
import Utils from "./Utils";

// User - Menus
export function UserMenus() {
    const userMenus = api.GetUserMenus;
    return fetch(userMenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message);
                return null;
            }
        })
}

// Refresh Token
export function RefreshToken() {
    const refresh = api.ManipurRefreshToken;
    return fetch(refresh, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message);
                return null;
            }
        })
}

// Verify reset password Token
export async function verifyToken(token: string) {
    const verify = api.ValidatePasswordToken + "/" + token;
    return fetch(verify, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            return result;
        })
}


// list, get account type
export function accountType(rowid: string | null) {
    let acc = api.AccountType;
    if (rowid) {
        acc += "/" + rowid;
    }
    return fetch(acc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Roles
export function listRoles() {
    const listRoles = api.RolesList;
    return fetch(listRoles, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message);
                return null;
            }
        })
}

// Get Roles
export function getRole(rowid: string) {
    const role = api.GetRole + '/' + rowid;
    return fetch(role, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Permission
export function listPermission() {
    const listPermission = api.PermissionsList;
    return fetch(listPermission, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Permissions
export function getPermission(rowid: string) {
    const permission = api.GetPermission + '/' + rowid;
    return fetch(permission, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Roles Permissions
export function listRolesPermission() {
    const listRP = api.RolePermissionsList;
    return fetch(listRP, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Roles Permissions
export function getRolePermission(rowid: string) {
    const rolePermision = api.GetRolePermission + '/' + rowid;
    return fetch(rolePermision, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Menus by account id
export function listMenusByAccId(id) {
    const listmenus = api.MenuListByAccountId + "/" + id;
    return fetch(listmenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Menus
export function listMenus() {
    const listmenus = api.MenuList;
    return fetch(listmenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Menu
export function getMenu(rowid: string) {
    const menu = api.GetMenu + '/' + rowid;
    return fetch(menu, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        },
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Menu Roles
export function listMenuRole() {
    const listMenuRoles = api.MenuRoleList;
    return fetch(listMenuRoles, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Menu Roles
export function getMenuRole(rowid: string) {
    const menurole = api.GetMenuRole + '/' + rowid;
    return fetch(menurole, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List Sub menus
export function listSubMenus() {
    const listSubMenus = api.SubMenuList;
    return fetch(listSubMenus, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Submenu
export function getSubmenu(rowid: string) {
    const submenu = api.GetSubMenu + '/' + rowid;
    return fetch(submenu, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get SubMenu by menu id
export function getSubmenusByMenu(mnuid: string) {
    const mnusubmenu = api.GetSubMenuByMenu + '/' + mnuid;
    return fetch(mnusubmenu, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List User RBAC
export function listUserRBAC() {
    const listUser = api.ListUserRBAC;
    return fetch(listUser, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get User RBAC
export function getUserRBAC(rowid: string) {
    const getUsr = api.GetUserRBAC + '/' + rowid;
    return fetch(getUsr, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list users
export function listUsers() {
    const listUsers = api.ListUsers;
    return fetch(listUsers, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}


// Get Users
export function getUser(rowid: string) {
    const getUsr = api.GetUser + '/' + rowid;
    return fetch(getUsr, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list sports
export function listSports() {
    const listSports = api.ListSports;
    return fetch(listSports, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Sport
export function getSport(rowid: string) {
    const getSprt = api.GetSport + '/' + rowid;
    return fetch(getSprt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list talent scouting
export function listTalentScouting() {
    const listTlntSctng = api.ListTalentScouting;
    return fetch(listTlntSctng, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Talent Scouting
export function getTalentScouting(rowid: string) {
    const getTlntSctng = api.GetTalentScouting + '/' + rowid;
    return fetch(getTlntSctng, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list talent scouting selection criteria
export function listTalentScoutingSelectionCriteria() {
    const listTlntSctng = api.ListTalentScoutingSelectionCriteria;
    return fetch(listTlntSctng, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Talent Scouting
export function getTalentScoutingSelectionCriteria(rowid: string) {
    const getTlntSctng = api.GetTalentScoutingSelectionCriteria + '/' + rowid;
    return fetch(getTlntSctng, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list GeoState
export function listGeoStates() {
    const listStates = api.ListGeoState;
    return fetch(listStates, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get GeoState
export function getGeoState(rowid: string) {
    const getState = api.GetGeoState + '/' + rowid;
    return fetch(getState, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Geo District
export function listGeoDistricts() {
    const listStates = api.ListGeoDistricts;
    return fetch(listStates, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Geo District
export function getGeoDistrict(rowid: string) {
    const getState = api.GetGeoDistrict + '/' + rowid;
    return fetch(getState, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Geo District by state id
export function listGeoDistrictByStateId(stateId: string | undefined) {
    const listStates = api.ListGeoDistrictsByStateId + '/' + stateId;
    return fetch(listStates, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Geo City
export function listGeoCity() {
    const listCity = api.ListGeoCity;
    return fetch(listCity, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Geo City
export function getGeoCity(rowid: string) {
    const getCity = api.GetGeoCity + '/' + rowid;
    return fetch(getCity, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Geo City by district id
export function listGeoCityByDistrictId(distId: string | undefined) {
    const listCity = api.ListGeoCityByDistrictId + '/' + distId;
    return fetch(listCity, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Geo Center
export function listGeoCenters() {
    const listCenter = api.ListGeoCenter;
    return fetch(listCenter, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Geo Center
export function getGeoCenter(rowid: string) {
    const getCenter = api.GetGeoCenter + '/' + rowid;
    return fetch(getCenter, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Geo Center by city id
export function listGeoCentersByCityId(cityId: string | undefined) {
    const listCenter = api.ListGeoCentersByCityId + '/' + cityId;
    return fetch(listCenter, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc 
export function hpc(rowid: string | null) {
    let hpc = api.HPC;
    if (rowid) {
        hpc += "/" + rowid;
    }
    return fetch(hpc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list sports
export function listAthleteSports() {
    const listSports = api.ListAthleteSports;
    return fetch(listSports, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Batches
export function listBatches() {
    const listBtches = api.ListBatches;
    return fetch(listBtches, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Batches
export function getBatch(rowid: string) {
    const getBatch = api.GetBatch + '/' + rowid;
    return fetch(getBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list coaches
export function listCoaches() {
    const lstCoach = api.ListCoaches;
    return fetch(lstCoach, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Batch Athlete
export function listBatchAthlete() {
    const listBtchesAthlete = api.ListBatchesAthletes;
    return fetch(listBtchesAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Athletes
export function listAllAthletes(rowid: string | null) {
    let listAthlete = api.Athlete;
    if (rowid) {
        listAthlete += "/" + rowid;
    }
    return fetch(listAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Athletes
export function listAllActiveAthletes() {
    const listAthlete = api.ActiveAthlete;
    return fetch(listAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Batch Athlete
export function getBatchAthlete(rowid: string) {
    const getBatchAthlete = api.GetBatchAthlete + '/' + rowid;
    return fetch(getBatchAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Active Athletes
export function listActiveAthletes() {
    const listActiveAthlete = api.ListActiveAthletes;
    return fetch(listActiveAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Schedules
export function listSchedules() {
    const listScdls = api.ListSchedules;
    return fetch(listScdls, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Schedules
export function getschedule(rowid: string) {
    const getScdl = api.GetSchedule + '/' + rowid;
    return fetch(getScdl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Assessment
export function listAssessments() {
    const listAsmnts = api.ListAssessments;
    return fetch(listAsmnts, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Assessment
export function getAssessment(rowid: string) {
    const getAsmnt = api.GetAssessment + '/' + rowid;
    return fetch(getAsmnt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function competitionType(rowid: string | null) {
    let getCompType = api.competitionType;
    if (rowid) {
        getCompType += "/" + rowid;
    }
    return fetch(getCompType, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function competitionSport(rowid: string | null) {
    let getCompSport = api.competitionSport;
    if (rowid) {
        getCompSport += "/" + rowid;
    }
    return fetch(getCompSport, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function competitionSportType(rowid: string | null) {
    let getCompSportType = api.competitionSportType;
    if (rowid) {
        getCompSportType += "/" + rowid;
    }
    return fetch(getCompSportType, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function competitions(rowid: string | null) {
    let getComps = api.competitions;
    if (rowid) {
        getComps += "/" + rowid;
    }
    return fetch(getComps, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function competitionPerformance(rowid: string | null) {
    let getCompPrfmnc = api.competitionPerformance;
    if (rowid) {
        getCompPrfmnc += "/" + rowid;
    }
    return fetch(getCompPrfmnc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function sportList(rowid: string | null) {
    let getsprtLst = api.sportList;
    if (rowid) {
        getsprtLst += "/" + rowid;
    }
    return fetch(getsprtLst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function coachByCenter(cntrid: string | null) {
    const cochLst = api.GetCoachByCenterId + '/' + cntrid;
    return fetch(cochLst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function sportByCoachId(cochid: string | null) {
    const sprtLst = api.GetSportByCoachId + '/' + cochid;
    return fetch(sprtLst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getSportAthleteByCompetition(compid: string | null) {
    const sprtAthltLst = api.GetSportAthletesByComp + '/' + compid;
    return fetch(sprtAthltLst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getTalentSctAthltList() {
    const sprtAthltLst = api.ListTalentScoutingAthletes;
    return fetch(sprtAthltLst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function centerBatch(rowid: string | null) {
    let getcntrBtch = api.CenterBatch;
    if (rowid) {
        getcntrBtch += "/" + rowid;
    }
    return fetch(getcntrBtch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function centerBatchAthelete(rowid: string | null) {
    let getbtchAthlt = api.CenterBatchAthlete;
    if (rowid) {
        getbtchAthlt += "/" + rowid;
    }
    return fetch(getbtchAthlt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getTsUnassignedBatches(rowid: string | null) {
    let getbtchs = api.GetTSUnassignedBatches;
    if (rowid) {
        getbtchs += "/" + rowid;
    }
    return fetch(getbtchs, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getUnassignedBatches(rowid: string | null) {
    let getbtchs = api.GetUnassignedBatches;
    if (rowid) {
        getbtchs += "/" + rowid;
    }
    return fetch(getbtchs, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list center Active Athletes
export function listCenterActiveAthletes(rowid: string | null) {
    let listActiveAthlete = api.ListCenterActiveAthletes;
    if (rowid) {
        listActiveAthlete += "/" + rowid;
    }
    return fetch(listActiveAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getBatchesByCenter(rowid: string | null) {
    let getbtchCenter = api.GetBatchesByCenter;
    if (rowid) {
        getbtchCenter += "/" + rowid;
    }
    return fetch(getbtchCenter, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getScheduleByBatchandCenter(cntrId: string, btchId: string) {
    const getscdlCenter = api.GetSchedulesByCenters + '/' + cntrId + '/' + btchId;
    return fetch(getscdlCenter, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getAthletesBySchedule(cntrId: any, batchId: any, scdlId: any) {
    const lstAthletes = api.GetAthletesBySchedule + '/' + cntrId + '/' + batchId + '/' + scdlId;
    return fetch(lstAthletes, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getSchedulesByBatch(centerId: string, batchId: string) {
    const getscdlBatch = api.GetSchedulesByBatch + '/' + centerId + '/' + batchId;
    return fetch(getscdlBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function getAthletesByAssessment(centerId: string, batchId: string, scheduleId: string, scdlTypeId: string) {
    const lstAthletes = api.ListAthletesByAssessment + '/' + centerId + '/' + batchId + '/' + scheduleId + '/' + scdlTypeId;
    return fetch(lstAthletes, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list HPC list by Geography
export function getHpcByGeography(geoId: string) {
    const lstHpc = api.GetHPCByGeography + '/' + geoId;
    return fetch(lstHpc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Coaches list by HPC
export function getCoachesByHpc(hpcId: string) {
    const HpcCoach = api.GetCoachesByHPC + '/' + hpcId;
    return fetch(HpcCoach, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Sport list by Coach
export function getSportsByCoach(cochId: string) {
    const HpcCoach = api.GetSportsByCoach + '/' + cochId;
    return fetch(HpcCoach, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}


// list Batches by HPC
export function getBatchByHpc(hpcId: string) {
    const HpcBatch = api.GetBatchByHpc + '/' + hpcId;
    return fetch(HpcBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Athletes by HPC
export function getAthletesByHpc(hpcId: string) {
    const HpcBatch = api.GetAthletesByHpc + '/' + hpcId;
    return fetch(HpcBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Schedules by HPC and batch
export function getSchedulesByHpcAndBatch(hpcId: string, btchId: string) {
    const HpcBatch = api.GetSchedulesByGeoandBatch + '/' + hpcId + '/' + btchId;
    return fetch(HpcBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Athletes by HPC
export function getHpcAthletesBySchedule(hpcId: string, batchId: string, scheduleId: string) {
    const HpcBatch = api.GetHPCAthletesBySchedule + '/' + hpcId + '/' + batchId + '/' + scheduleId;
    return fetch(HpcBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Schedules by HPC and batch
export function getSchedulesByHpcBatch(hpcId: string, btchId: string) {
    const HpcBatch = api.GetHpcSchedulesByBatch + '/' + hpcId + '/' + btchId;
    return fetch(HpcBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list Athletes by HPC
export function getHpcAthletesByAssessment(hpcId: string, batchId: string, scheduleId: string, scdlTyp: string) {
    const HpcBatch = api.GetAthletesByAssessment + '/' + hpcId + '/' + batchId + '/' + scheduleId + '/' + scdlTyp;
    return fetch(HpcBatch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// List, get skill
export function skills(rowid: string | null) {
    let skil = api.Skills;
    if (rowid) {
        skil += "/" + rowid;
    }
    return fetch(skil, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get scheduleType
export function scheduleType(rowid: string | null) {
    let scdlTyp = api.ScheduleType;
    if (rowid) {
        scdlTyp += "/" + rowid;
    }
    return fetch(scdlTyp, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get program
export function program(rowid: string | null) {
    let prog = api.Program;
    if (rowid) {
        prog += "/" + rowid;
    }
    return fetch(prog, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get center schedule
export function centerSchedule(rowid: string | null) {
    let scdl = api.CenterSchedule;
    if (rowid) {
        scdl += "/" + rowid;
    }
    return fetch(scdl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get center attendance
export function centerAttendance(rowid: string | null) {
    let atndc = api.CenterAttendance;
    if (rowid) {
        atndc += "/" + rowid;
    }
    return fetch(atndc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get center assessment
export function centerAssessment(rowid: string | null) {
    let asmnt = api.CenterAssessment;
    if (rowid) {
        asmnt += "/" + rowid;
    }
    return fetch(asmnt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list center batch athletes
export function centerBatchAthletes(centerId: string, batchId: string) {
    const athlt = api.CenterBatchAthletes + '/' + centerId + '/' + batchId;
    return fetch(athlt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assessment type
export function assessmentType(rowid: string | null) {
    let asmnt = api.AssessmentType;
    if (rowid) {
        asmnt += "/" + rowid;
    }
    return fetch(asmnt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get grade type
export function gradelist(rowid: string | null) {
    let grade = api.GradeType;
    if (rowid) {
        grade += "/" + rowid;
    }
    return fetch(grade, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get attendance type
export function attendanceType(rowid: string | null) {
    let atndc = api.AttendanceType;
    if (rowid) {
        atndc += "/" + rowid;
    }
    return fetch(atndc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}


// list hpc Athletes
export function listHPCAthletes(rowid: string | null) {
    let listAthlete = api.HPCAthletes;
    if (rowid) {
        listAthlete += "/1/" + rowid;
    }
    return fetch(listAthlete, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc batch
export function hpcBatch(rowid: string | null) {
    let btch = api.HPCBatch;
    if (rowid) {
        btch += "/" + rowid;
    }
    return fetch(btch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

export function hpcBatchAthelete(rowid: string | null) {
    let btchAthlt = api.HPCBatchAthlete;
    if (rowid) {
        btchAthlt += "/" + rowid;
    }
    return fetch(btchAthlt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc schedule
export function hpcSchedule(rowid: string | null) {
    let scdl = api.HPCSchedules;
    if (rowid) {
        scdl += "/" + rowid;
    }
    return fetch(scdl, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc attendance
export function hpcAttendance(rowid: string | null) {
    let atndc = api.HPCAttendance;
    if (rowid) {
        atndc += "/" + rowid;
    }
    return fetch(atndc, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get hpc assessment
export function hpcAssessment(rowid: string | null) {
    let asmnt = api.HPCAssessment;
    if (rowid) {
        asmnt += "/" + rowid;
    }
    return fetch(asmnt, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Metrics
export function getMertricsData(athltId: string) {
    const metrics = api.AthleteMetricsData;
    const formData = new FormData();
    formData.append('athleteId', athltId)
    return fetch(metrics, {
        method: "POST",
        headers: {
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        },
        body: formData
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// Get Metricscale
export function getMertricScale() {
    const metrics = api.MetricScale;
    return fetch(metrics, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list injury
export function listInjury(rowid: string | null) {
    let inj = api.ListInjury;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get injury
export function injury(rowid: string | null) {
    let inj = api.Injury;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list injury Assessment
export function listInjuryAssessment(rowid: string | null) {
    let inj = api.ListInjuryAssessment;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get injury Assessment
export function injuryAssessment(rowid: string | null) {
    let inj = api.InjuryAssessment;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get injury Assessment schema
export function injuryAssessmentSchema(rowid: string | null) {
    let inj = api.InjuryAssessmentSchema;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            return result;
            // if (result.error == false) {
            //     return result;
            // }
            // else {
            //     if (result.code == 401) {
            //         Utils.logoutUser();
            //     }
            //     Swal.fire(result.message)
            // }
        })
}

// list injury diagnosis
export function listInjuryDiagnosis(rowid: string | null) {
    let inj = api.ListInjuryDiagnosis;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get injury diagnosis
export function injuryDiagnosis(rowid: string | null) {
    let inj = api.InjuryDiagnosis;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list injury treatment
export function listInjuryTreatment(rowid: string | null) {
    let treat = api.ListInjuryTreatment;
    if (rowid) {
        treat += "/" + rowid;
    }
    return fetch(treat, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get injury treatment
export function injuryTreatment(rowid: string | null) {
    let treat = api.InjuryTreatment;
    if (rowid) {
        treat += "/" + rowid;
    }
    return fetch(treat, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get screening
export function listScreening(rowid: string | null) {
    let treat = api.ListScreening;
    if (rowid) {
        treat += "/" + rowid;
    }
    return fetch(treat, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get screening
export function screening(rowid: string | null) {
    let treat = api.Screening;
    if (rowid) {
        treat += "/" + rowid;
    }
    return fetch(treat, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get athlete-profile-info
export function athleteInfo(athlete: string) {
    const profile = api.AthleteProfileInfo + "/" + athlete;
    return fetch(profile, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get blood group
export function bloodGroup(rowid: string | null) {
    let bldGrp = api.BloodGroup;
    if (rowid) {
        bldGrp += "/" + rowid;
    }
    return fetch(bldGrp, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get allergy type
export function allergyType(rowid: string | null) {
    let alrgyTyp = api.AllergyType;
    if (rowid) {
        alrgyTyp += "/" + rowid;
    }
    return fetch(alrgyTyp, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get medication category
export function medicationCategory(rowid: string | null) {
    let medCtgry = api.MedicationCtgry;
    if (rowid) {
        medCtgry += "/" + rowid;
    }
    return fetch(medCtgry, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get alcohol
export function alcohol(rowid: string | null) {
    let alcohol = api.Alcohol;
    if (rowid) {
        alcohol += "/" + rowid;
    }
    return fetch(alcohol, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get tobacco
export function tobacco(rowid: string | null) {
    let tbco = api.Tobacco;
    if (rowid) {
        tbco += "/" + rowid;
    }
    return fetch(tbco, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury type
export function injuryType(rowid: string | null) {
    let inj = api.InjuryType;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get region affected
export function regionAffected(rowid: string | null) {
    let rgn = api.RegionAffected;
    if (rowid) {
        rgn += "/" + rowid;
    }
    return fetch(rgn, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get diagnosis type
export function diagnosisType(rowid: string | null) {
    let diag = api.DiagnosisType;
    if (rowid) {
        diag += "/" + rowid;
    }
    return fetch(diag, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury severity
export function injurySeverity(rowid: string | null) {
    let inj = api.InjurySeverity;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury mechanism
export function injuryMechanism(rowid: string | null) {
    let inj = api.InjuryMechanism;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury management
export function injuryManagement(rowid: string | null) {
    let inj = api.InjuryManagement;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get time lost
export function timeLost(rowid: string | null) {
    let time = api.TimeLost;
    if (rowid) {
        time += "/" + rowid;
    }
    return fetch(time, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get surgery category
export function surgeryCategory(rowid: string | null) {
    let surg = api.SurgeryCategory;
    if (rowid) {
        surg += "/" + rowid;
    }
    return fetch(surg, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get body region
export function bodyRegion(rowid: string | null) {
    let bdy = api.BodyRegion;
    if (rowid) {
        bdy += "/" + rowid;
    }
    return fetch(bdy, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get rehabilitation duration
export function rehabilitationDuration(rowid: string | null) {
    let rehab = api.RehabilitationDuration;
    if (rowid) {
        rehab += "/" + rowid;
    }
    return fetch(rehab, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get physiological type
export function physiologicalType(rowid: string | null) {
    let physio = api.PhysiologicalType;
    if (rowid) {
        physio += "/" + rowid;
    }
    return fetch(physio, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get screening test type
export function screeningTestType(rowid: string | null) {
    let screen = api.ScreeningTestType;
    if (rowid) {
        screen += "/" + rowid;
    }
    return fetch(screen, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get symptom type
export function symptomType(rowid: string | null) {
    let symp = api.SymptomType;
    if (rowid) {
        symp += "/" + rowid;
    }
    return fetch(symp, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get pain location type
export function painLocationType(rowid: string | null) {
    let pain = api.PainLocationType;
    if (rowid) {
        pain += "/" + rowid;
    }
    return fetch(pain, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get functional limitations type
export function functionalLimitationsType(rowid: string | null) {
    let func = api.FunctionalLimitationsType;
    if (rowid) {
        func += "/" + rowid;
    }
    return fetch(func, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get injury treatment type
export function injuryTreatmentType(rowid: string | null) {
    let inj = api.InjuryTreatmentType;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get concussion specific symptom
export function concussionSpecificSymptom(rowid: string | null) {
    let css = api.ConcussionSpecificSymptom;
    if (rowid) {
        css += "/" + rowid;
    }
    return fetch(css, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get onset
export function onset(rowid: string | null) {
    let onst = api.Onset;
    if (rowid) {
        onst += "/" + rowid;
    }
    return fetch(onst, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get performance test
export function performanceTest(rowid: string | null) {
    let prfrm = api.PerformanceTest;
    if (rowid) {
        prfrm += "/" + rowid;
    }
    return fetch(prfrm, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assign coach to center
export function centerCoach(rowid: string | null) {
    let coch = api.AssignCoachToCenter;
    if (rowid) {
        coch += "/" + rowid;
    }
    return fetch(coch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assign ops to center
export function centerOps(rowid: string | null) {
    let ops = api.AssignOpsToCenter;
    if (rowid) {
        ops += "/" + rowid;
    }
    return fetch(ops, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assign biz to center
export function centerBiz(rowid: string | null) {
    let biz = api.AssignBizToCenter;
    if (rowid) {
        biz += "/" + rowid;
    }
    return fetch(biz, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assign coach to hpc
export function hpcCoach(rowid: string | null) {
    let coch = api.AssignCoachToHPC;
    if (rowid) {
        coch += "/" + rowid;
    }
    return fetch(coch, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assign ops to hpc
export function hpcOps(rowid: string | null) {
    let ops = api.AssignOpsToHPC;
    if (rowid) {
        ops += "/" + rowid;
    }
    return fetch(ops, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list, get assign biz to hpc
export function hpcBiz(rowid: string | null) {
    let biz = api.AssignBizToHPC;
    if (rowid) {
        biz += "/" + rowid;
    }
    return fetch(biz, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list overall assessment
export function listOverallAssessment(rowid: string | null) {
    let inj = api.ListOverallAssessment;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// resume assessment
export function resumeAssessment(rowid: string | null) {
    let inj = api.ResumeAssessment;
    if (rowid) {
        inj += "/" + rowid;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// view assessment details
export function viewAssessmentDetails(assessId: string) {
    let inj = api.ListOverallAssessment;
    if (assessId) {
        inj += "/" + assessId + "/details";
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get pyschology ui schema
export function uiPsychologicalSchema() {
    const ui = api.PsychologyUiSchema;
    return fetch(ui, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list pyschology
export function listPyschology() {
    const ui = api.ListPsychologyAssessment;
    return fetch(ui, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// view pyschology
export function viewPsychology(athltId: string) {
    let inj = api.ViewPsychologyAssessment;
    if (athltId) {
        inj += "/" + athltId ;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// get psychological-acsi ui schema
export function uiPsychologicalSchemaAcsi() {
    const ui = api.PsychologyAcsiUiSchema;
    return fetch(ui, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// list psychological-acsi
export function listPyschologyAcsi() {
    const ui = api.ListPsychologyAcsiAssessment;
    return fetch(ui, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// view psychological-acsi
export function viewPsychologyAcsi(athltId: string) {
    let inj = api.ViewPsychologyAcsiAssessment;
    if (athltId) {
        inj += "/" + athltId ;
    }
    return fetch(inj, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}

// logout
export function logout() {
    const lgout = api.ManipurLogout;
    return fetch(lgout, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + Utils.getAccessToken()
        }
    })
        .then((response) => response.json())
        .then((result) => {
            if (result.error == false) {
                return result.data;
            }
            else {
                if (result.code == 401) {
                    Utils.logoutUser();
                }
                Swal.fire(result.message)
            }
        })
}
